import React, { Component } from 'react';
export const Page = props => (
  <div className="project">

    {/* ==== EDIT BELOW THIS LINE ==== */}
    
    <h1> "Gunning for Change" News Magazine Cover </h1>

    <p> During my time as Art Director of Verde Magazine, I illustrated the external
    covers and the internal graphics to pair with news articles. The below cover 
    illustration was made to pair with Volume 14 Issue 4, which covered the topic of 
    gun control, addressing local and national perspectives. </p>

    <div className="imgs max700">
        <div>
            <img 
                src={require('../assets/verde/covers/verdeGun.jpg')} 
                onClick={props.open}
            />
        </div>
    </div>




    {/* ==== EDIT ABOVE THIS LINE ==== */}

  </div>
)